export default `
# Errors

Most API errors are returned as an HTTP error status code together with a plain-text body
that starts with an error code in brackets, followed by a short human-readable description.
An API integration request received by PostaMail from an IP address outside the account's
allowlist is also rejected with HTTP 403 Forbidden. This response may have an empty body
with no stable error code.

\`\`\`text
[ERR_AUTH_SESSION_EXPIRED] Session expired
\`\`\`

## Reading an error

- The bracketed token (e.g. \`ERR_AUTH_SESSION_EXPIRED\`) is stable and safe to match on
  in your integration code.
- The text after it is meant for logs/humans and **may change** between releases —
  do not parse it.

## Common error codes

| Code                          | Meaning                                              |
|-------------------------------|-------------------------------------------------------|
| \`ERR_AUTH_SESSION_EXPIRED\`    | The session/refresh cookie or token is no longer valid. |
| \`ERR_AUTH_INVALID_CREDENTIALS\`| The email/password combination is not valid.          |
| \`ERR_VALIDATION\`              | The request body failed validation.                   |
| \`ERR_NOT_FOUND\`               | The requested resource does not exist, or you don't have access to it. |
| \`ERR_FORBIDDEN\`               | The current session's role does not allow this action.|
| \`ERR_OUTBOX_INVALIDATED\`      | The shipment was invalidated. Reason provided in the response body. |

An API integration request from an IP address outside the account's allowlist also receives HTTP 403 Forbidden. This IP restriction response may have an empty body and does not include a stable error code.
`



// WEBPACK FOOTER //
// ./src/components/docs/api/content/errors.js